import { formatLeaveType } from "../../../utils/helpers";

const LEAVE_TYPE_LABEL_MAP = {
  PTO_VACATION_REQUEST: "PTO Vacation Request",
  SickLeave: "Sick Leave",
  PERSONAL_APPOINTMENT: "Personal Appointment",
  BEREAVEMENT: "Bereavement",
  MATERNITY: "Maternity Leave",
  PATERNITY: "Paternity Leave",
  QUARTERLY: "Quarterly Leave",
  QuarterlyLeave: "Quarterly Leave",
  quarterlyLeave: "Quarterly Leave",
  SHORT_LEAVE: "Short Leave",
  ShortLeave: "Short Leave",
  shortLeave: "Short Leave",
};

export const formatLeaveTypeLabel = (leaveType) => {
  if (!leaveType) return "-";
  return LEAVE_TYPE_LABEL_MAP[leaveType] || formatLeaveType(leaveType);
};

